<template>
    <el-row class="screen-make-video" :gutter="20" type="flex">
        <el-col :span="6" class="makeVideo-item create-makeVideo">
            <upload class="makeVideo-upload" :tip="$t('xian_zhi_fen_bian_lv_can_kao_ji_xing_fen_bian_lv_shou_ce')" :accept="'video/mp4,video/x-flv'"
                    :uploadSuccess="uploadSuccess"></upload>
        </el-col>
        <el-col :span="6" v-for="(item, index) in videos" :key="index">
            <div class="makeVideo-item">
                <img :src="item.url+'?x-oss-process=video/snapshot,t_1000,f_jpg,w_1024,h_600,m_fast'" @click="showVideo(item)"/>
                <p class="make-video-item-text-info" @click="editLogo(item)">
                    <span>{{$t('bian_ji')}}</span>
                </p>
            </div>
        </el-col>
        <c-dialog :visible.sync="videoViewerVisible" :width="'34rem'" :height="'22rem'">
            <video width="512" height="300" autoplay controls :src="url">{{$t('nin_de_liu_lan_qi_zan_shi_bu_zhi_chi_shi_pin')}}</video>
        </c-dialog>
    </el-row>

</template>

<script>
    import Upload from '@/components/Upload'
    import CDialog from '@/components/Dialog'
    import {makeVideoCreate, makeVideoList} from '@/api/delivery/device/makeVideo'
    export default {
        name: '',
        components: {
            CDialog,
            Upload
        },
        mounted: function () {
            this.loadLogos()
        },
        data: function () {
            return {
                uploadVisible: false,
                videoViewerVisible: false,
                url: '',
                videos: [],
            }
        },
        methods: {
            closeViewer() {
                this.videoViewerVisible = false
            },
            showVideo(item){
                this.url = item.url
                this.videoViewerVisible = true
            },
            loadLogos() {
                makeVideoList().then(res => {
                    this.videos = res.data || []
                })
            },
            editLogo(item){
                this.$router.push({name: 'delivery.devices.screenManager.makeVideo.detail', params: item})
            },
            uploadSuccess(url){
                let makeVideo = {
                    url: url,
                }

                makeVideoCreate(makeVideo).then(res => {
                    makeVideo.uuid = res.data
                    this.$message.success(this.$t('shang_chuan_cheng_gong'))
                    this.videos.unshift(makeVideo)
                })
            }
        },
    }
</script>

<style lang="scss">
    .screen-make-video {
        margin-bottom: $padding;
        flex-flow: row wrap;
        align-content: flex-start;
        .makeVideo-item {
            background-color: $bg_sec_color;
            border: .2rem;
            margin-bottom: $padding;
            img {
                width: 100%;
                height: 100%;
                cursor: pointer;
            }
            .make-video-item-text-info {
                padding: $padding-5;
                font-size: .6rem;
                color: $f_sec_color;
                text-align: center;
                span {
                    cursor: pointer;
                }
                span:hover {
                    color: $f_color;
                }
                .look-devices {
                    margin-left: $padding-5;
                    display: inline-block;
                }
            }
        }

        .create-makeVideo {
            background-color: transparent;
            .makeVideo-upload {
                height: 100%;
                width: 100%;
            }
        }

    }
</style>
